import FreeFormStatementStepOne from "./step-1";

import { StatementComponentNames } from "../../../helpers/data";

const FreeFormStatement = {
    name: StatementComponentNames.free_form.free_form_index,

    data() {
        return {
            statement_anchor: "statement_freeform_main_body",
            current_component: FreeFormStatementStepOne,
        };
    },

    components: {
        FreeFormStatementStepOne,
    },

    methods: {
        goToComponent({ component }) {
            this.current_component = component;
        },
    },

    template: /*html*/ `
    <div :id="statement_anchor"></div>
    <div class="statement theme-light money-refund">
      <div class="container">
      <transition name="fade" mode="out-in">
        <!-- <router-view
          :statement-anchor="statement_anchor"
        /> -->
        <component :is="current_component" :goToComponent="goToComponent" :statement-anchor="statement_anchor"></component>
       </transition >
      </div>
    </div>
  `,
};

export default FreeFormStatement;
